/**
 * Sets the `value` at the given `path.
 * It makes a copy of all the objects encountered along the way.
 * @param {Object} obj
 * @param {string} path
 * @param {any} value
 * @param {Object} [options={}]
 *        {number} [option.step]
 */
export function setUtil (obj, path, value, options = {}) {
  if (!obj) {
    console.warn(`[setUtil] [null] [${path}]: `, value)
    obj = {}
  }
  const dotIndex = path.indexOf('.')
  // If it's a shallow attribute, set the attribute
  if (
    dotIndex === -1 &&
    typeof value === 'undefined'
  ) {
    const newObj = { ...obj }
    delete newObj[path]
    return newObj
  }
  const stepOption = options.step
  const currentStep = options.currentStep || 0
  if (
    dotIndex === -1 ||
    (stepOption != null && currentStep === stepOption)
  ) {
    return {
      ...obj,
      [path]: value
    }
  }

  // Get the next path to set
  const key = path.slice(0, dotIndex)
  const nextPath = path.slice(dotIndex + 1)

  // Make a copy of the current `obj` and set
  // the deep attribute
  return {
    ...obj,
    [key]: setUtil(obj[key], nextPath, value, {
      ...options,
      currentStep: currentStep + 1
    })
  }
}
